enum RapportVisning {
  redigerRapportView,
  levertRapportView,
  lesRapportView,
  godkjentRapportView
}

export default RapportVisning;
